// Set webchat configuration
var daktelaGuiConfig = {
    "server":"https://comfortclick.daktela.com/",
    "accessToken":"4sn9748sn2228536n50q3pq4rro90n43"
};
// Create async script element
var daktelaWeb = null;
var daktelaScriptEl = document.createElement("script");
(function (attrs) { Object.keys(attrs).forEach(function (key) { daktelaScriptEl.setAttribute(key, attrs[key]); }); })
({"src":daktelaGuiConfig.server+"external/web/web.js", "type":"text/javascript", "async":true, "charset":"utf-8"});
daktelaScriptEl.onload = function() { if (!daktelaGui) return; daktelaWeb = new daktelaGui(); daktelaWeb.init(daktelaGuiConfig); };
document.getElementsByTagName("head")[0].appendChild(daktelaScriptEl);

function clickChatContainer() {
  const chatContainer = document.querySelector('.dw-button');

  if (chatContainer) {
    chatContainer.click();
  }
}